module.exports = __webpack_public_path__ + "la.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/la.svg
// module id = 653
// module chunks = 0